module.exports = __webpack_public_path__ + "img/homescreen-capacitor.6bf12612.webp";